import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import ModalAsignarOficio from './ModalAsignarOficio';

import getRegistrosEntradasSalidas from '../../../graphql/querys/registroEntradaSalida/getRegistrosEntradasSalidas.graphql';
import deleteRegistroEntradaSalida from '../../../graphql/mutations/registroEntradaSalida/deleteRegistroEntradaSalida.graphql';

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getRegistrosEntradasSalidasPorRangoConFiltros from '../../../graphql/querys/registroEntradaSalida/getRegistrosEntradasSalidasPorRangoConFiltros.graphql';
import getCantidadRegistrosEntradasSalidasPorRangoConFiltros from '../../../graphql/querys/registroEntradaSalida/getCantidadRegistrosEntradasSalidasPorRangoConFiltros.graphql';

import TablaRegistroEntradaSalida from './TablaRegistroEntradaSalida';

import ReImprimirNota from '../ReImprimirNota';
import { imprimir } from '../../common/funciones/imprimir';

const confirm = Modal.confirm;
@compose(
  graphql(getUsuario),
  graphql(deleteRegistroEntradaSalida, {
    name: 'deleteRegistroEntradaSalida',
    options: {
      refetchQueries: [{ query: getRegistrosEntradasSalidas }],
    },
  })
)
class ListarRegistroEntradaSalida extends React.Component {
  constructor(props) {
    super(props);

    let fechaIni = moment()
      .subtract(7, 'd')
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toDate();

    let fechaFin = moment()
      .endOf('day')
      .toDate();

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
      imprimir: false,
      datosImpresion: {},
      fechaInicio: fechaIni,
      fechaFin: fechaFin,
      pagina: 1,
      cantidadPorPagina: 10,
      cantidadTotal: 0,
      modalVisible: false,
      idRegistroModal: null,
      loadingTabla: false,
    };

    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    this.getRegistrosEntradasSalidasPorRangoConFiltros();
  }

  getRegistrosEntradasSalidasPorRangoConFiltros = () => {
    this.setState({ loadingTabla: true });
    this.props.client
      .query({
        query: getCantidadRegistrosEntradasSalidasPorRangoConFiltros,
        variables: {
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
        },
      })
      .then(resp => {
        if (
          resp.data.getCantidadRegistrosEntradasSalidasPorRangoConFiltros ||
          resp.data.getCantidadRegistrosEntradasSalidasPorRangoConFiltros == 0
        ) {
          this.setState({
            cantidadTotal:
              resp.data.getCantidadRegistrosEntradasSalidasPorRangoConFiltros,
          });

          this.props.client
            .query({
              query: getRegistrosEntradasSalidasPorRangoConFiltros,
              variables: {
                fechaInicial: this.state.fechaInicio,
                fechaFinal: this.state.fechaFin,
                pagina: this.state.pagina,
                cantidadPorPagina: this.state.cantidadPorPagina,
              },
              fetchPolicy: 'network-only',
            })
            .then(res => {
              if (res.data) {
                this.setState(
                  {
                    ...this.state,
                    listaTotal:
                      res.data.getRegistrosEntradasSalidasPorRangoConFiltros,
                    listaOriginal:
                      res.data.getRegistrosEntradasSalidasPorRangoConFiltros,
                    primeraCarga: false,
                    loadingTabla: false,
                  },
                  function() {
                    this.ordenarLista(
                      this.state.pagina,
                      this.state.cantidadPorPagina
                    );
                  }
                );
              } else {
                Modal.error({
                  title: 'No se encontraron Registros de E/S',
                  content:
                    'Los filtros indicados no concluyeron con una busqueda satisfactoria, por favor, ingrese otros datos',
                });
                this.setState({
                  ...this.state,
                  loading: false,
                });
              }
            })
            .catch(err => {
              console.log('ERROR EN EL REGISTROS DE E/S POR RANGO: ');
              console.log(err);

              Modal.error({
                title: 'Error en la busqueda de registros de E/S',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        }
      })
      .catch(err => {
        console.log(
          'ERROR A LA HORA DE OBTENER LA CANTIDAD TOTAL DE DOCUMENTOS'
        );
        console.log('EL ERROR ES: ', err);
      });
  };

  onDelete(id) {
    //TODO: Hacer el onDelete.
    // console.log("Se desea eliminar la declaracion jurada con id ", id);

    // console.log("USUARIOOOOOOO: ");
    // console.log(this.props.usuario);

    let { usuario } = this.props;

    if (usuario.rol == 'SUPERVISOR' || usuario.rol == 'FUNCIONARIO') {
      let yo = this;
      confirm({
        title: 'Realmente quiere eliminar este Registro de Entrada y Salida?',
        content: 'Esta accion no podrá deshacerse',
        onOk() {
          yo.props
            .deleteRegistroEntradaSalida({
              variables: { _id: id },
            })
            .then(res => {
              // console.log("La respuesta del delete fue....");
              // console.log(res);

              let id = res.data.deleteRegistroEntradaSalida;

              if (id) {
                yo.eliminarElementoYActualizarLista(id);

                notification.warning({
                  message: 'Registro de Entrada/Salida eliminado',
                  description: 'Se ha eliminado el registro exitosamente',
                });
              }
            })
            .catch(err => {
              console.log(
                'Existio un error a la hora de eliminar el registro de entrada/salida'
              );
              console.log(err);

              Modal.error({
                title: 'Error en la eliminacion del registro de entrada/salida',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      Modal.error({
        title:
          'Usted no tiene los permisos necesarios para realizar esta operación',
        content:
          'Para poder realizar esta función, debe tener mas permisos en su cuenta de los que tiene ahora mismo. Por favor, en caso de ser necesario, comuníquese con mesa de ayuda del departamento de informática.',
      });
    }
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];
    let total = this.state.cantidadTotal;

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
        cantidadTotal: total - 1,
      },
      function() {
        this.ordenarLista(this.state.pagina, this.state.cantidadPorPagina);
      }
    );
  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState(
      {
        ...this.state,
        filtroNombre: filtro,
        pagina: 1,
      },
      () => {
        this.getRegistrosEntradasSalidasPorRangoConFiltros();
      }
    );
  };

  filtrarPorApellido = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState(
      {
        ...this.state,
        filtroApellido: filtro,
        pagina: 1,
      },
      () => {
        this.getRegistrosEntradasSalidasPorRangoConFiltros();
      }
    );
  };

  filtrarPorDocumento = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState(
      {
        ...this.state,
        filtroDocumento: filtro,
        pagina: 1,
      },
      () => {
        this.getRegistrosEntradasSalidasPorRangoConFiltros();
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    this.setState(
      {
        ...this.state,
        fechaInicio: date[0]
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate(),
        fechaFin: date[1]
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .toDate(),
      },
      () => {
        this.getRegistrosEntradasSalidasPorRangoConFiltros();
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        registro => {
          // return declaracion.declarante.apellido.toUpperCase();
          return registro.fechaCreacion;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaOrdenada,
    });
  };

  onImprimir = registro => {
    let texto = registro.textoNota
      ? registro.textoNota
      : registro.textoHtml
      ? registro.textoHtml
      : null;
    imprimir(texto);
  };

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
      },
      () => {
        this.getRegistrosEntradasSalidasPorRangoConFiltros();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  abrirModalAsignar = id => {
    this.setState({
      ...this.state,
      modalVisible: true,
      idRegistroModal: id,
    });
  };

  ocultarModalAsignar = () => {
    this.setState(
      {
        ...this.state,
        modalVisible: false,
      },
      () => {
        this.getRegistrosEntradasSalidasPorRangoConFiltros();
      }
    );
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };
    return (
      <div>
        {!this.state.imprimir && (
          <TablaRegistroEntradaSalida
            registroEntradaSalida={this.state.lista}
            history={this.props.history}
            onDelete={this.onDelete}
            pagination={pagination}
            filtrarPorNombre={this.filtrarPorNombre}
            filtrarPorApellido={this.filtrarPorApellido}
            filtrarPorDocumento={this.filtrarPorDocumento}
            imprimir={this.onImprimir}
            onChange={this.onChange}
            onDescargar={this.onDescargar}
            fechaInicio={this.state.fechaInicio}
            fechaFin={this.state.fechaFin}
            cambiarPagina={this.cambiarPagina}
            cambiarTamañoPagina={this.cambiarTamañoPagina}
            total={this.state.cantidadTotal}
            pagina={this.state.pagina}
            cantidadPorPagina={this.state.cantidadPorPagina}
            abrirModalAsignar={this.abrirModalAsignar}
            loadingTabla={this.state.loadingTabla}
          />
        )}

        {this.state.imprimir && (
          <ReImprimirNota
            datos={this.state.datosImpresion}
            idModeloNota={this.state.datosImpresion.modelo_nota._id}
            onCancel={() => this.setState({ ...this.state, imprimir: false })}
          />
        )}

        <ModalAsignarOficio
          visibleAsignarOficio={this.state.modalVisible}
          _id={this.state.idRegistroModal}
          ocultarModalAsignar={this.ocultarModalAsignar}
        />
      </div>
    );
  }
}

export default withApollo(ListarRegistroEntradaSalida);
